const emailRegex =
  /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@[a-zA-Z0-9-]{1,252}(?:\.[a-zA-Z0-9-]{1,252})+/;

interface GetEmailRegexParams {
  global?: boolean;
  mailto?: 'optional' | 'required';
}

export const getEmailRegex = ({ mailto, global }: GetEmailRegexParams = {}) => {
  let mailtoPattern = '';

  if (mailto === 'required') {
    mailtoPattern = 'mailto:';
  }

  if (mailto === 'optional') {
    mailtoPattern = '(?:mailto:)?';
  }

  const pattern = `${mailtoPattern}${emailRegex.source}`;

  return global ? new RegExp(pattern, 'gi') : new RegExp(`^${pattern}$`, 'i');
};
